// 전체매물 차량별 문의 모달 — 목록(AuctionBuyerInventoryList) + 상세(AuctionBuyerInventoryDetail) 공용.
// 온플랫폼 inquiry (탈중개 방어). 백엔드: POST /api/buyer-app/inventory/:id/inquiry.

import React, { useState } from 'react';
import { API } from '../../utils/api';
import { authBuyerFetch, isUnauthorized, handleUnauthorized, displayApiError } from './buyerApi';
import { showToast } from './Toast';

function buyerLocale() {
  try { return localStorage.getItem('autodex_buyer_locale') || 'en'; } catch (e) { return 'en'; }
}

function InventoryInquiryModal(props) {
  var car = props.car;
  var t = props.t;
  var [message, setMessage] = useState('');
  var [sending, setSending] = useState(false);

  function send() {
    setSending(true);
    authBuyerFetch(API + '/buyer-app/inventory/' + car.id + '/inquiry', {
      method: 'POST',
      body: JSON.stringify({ message: message.trim(), locale: buyerLocale() }),
    })
      .then(function(r) {
        if (isUnauthorized(r)) { handleUnauthorized(props.navigate); throw new Error('unauthorized'); }
        return r.json();
      })
      .then(function(d) {
        setSending(false);
        if (d && d.success) { showToast(t('invInquirySent')); props.onClose(); }
        else { showToast(displayApiError(d, t, 'invInquiryFailed'), { type: 'error' }); }
      })
      .catch(function(e) {
        setSending(false);
        if (e && e.message === 'unauthorized') return;
        showToast(t('commonNetwork'), { type: 'error' });
      });
  }

  return (
    <div onClick={props.onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div onClick={function(e){ e.stopPropagation(); }} style={{ background: 'white', borderRadius: 18, padding: 28, width: '100%', maxWidth: 440 }}>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: '#0f172a', marginBottom: 6 }}>{t('invInquiryTitle')}</h3>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
          {car.carType}{car.seller ? ' · 🏢 ' + (car.seller.companyNameEn || car.seller.companyName) : ''}
        </div>
        <textarea value={message} onChange={function(e){ setMessage(e.target.value); }}
          placeholder={t('invInquiryPlaceholder')} rows={5} maxLength={1000}
          style={{ width: '100%', border: '1.5px solid #e2e8f0', borderRadius: 12, padding: 12, fontSize: 14, resize: 'vertical', outline: 'none', boxSizing: 'border-box' }} />
        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button type="button" onClick={props.onClose}
            style={{ flex: 1, height: 46, border: '1.5px solid #e2e8f0', borderRadius: 12, background: 'white', color: '#64748b', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
            {t('commonCancel')}
          </button>
          <button type="button" onClick={send} disabled={sending}
            style={{ flex: 2, height: 46, border: 'none', borderRadius: 12, background: sending ? '#cbd5e1' : 'linear-gradient(135deg,#1B3A5C 0%,#3b82f6 100%)', color: 'white', fontSize: 14, fontWeight: 700, cursor: sending ? 'not-allowed' : 'pointer' }}>
            {sending ? t('invInquirySending') : t('invInquirySend')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default InventoryInquiryModal;
